import { render, staticRenderFns } from "./BaseCardButton.vue?vue&type=template&id=c65ff8e8&"
import script from "./BaseCardButton.vue?vue&type=script&lang=ts&"
export * from "./BaseCardButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports